// Module
var code = "<div class=\"organize-container\" page-tracker=\"documents/organize\"> <ecv-organize redirect-to=\"organizeVm.redirectTo\" display-for=\"{{organizeVm.displayFor}}\" upload-type=\"multiple\"></ecv-organize> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/uploadDocuments/components/organizePage/organize-page.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;